const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const EventReport = () => import(/* webpackChunkName: "report" */'@/components/pages/report/EventReport');
const RequestReport = () => import(/* webpackChunkName: "report" */'@/components/pages/report/RequestReport');
const KnowledgeReport = () => import(/* webpackChunkName: "report" */'@/components/pages/report/KnowledgeReport');
const ProjectReport = () => import(/* webpackChunkName: "report" */'@/components/pages/report/ProjectReport');
const ReleaseReport = () => import(/* webpackChunkName: "report" */'@/components/pages/report/ReleaseReport');
const AssetReport = () => import(/* webpackChunkName: "report" */'@/components/pages/report/AssetReport');
const ChangeReport = () => import(/* webpackChunkName: "report" */'@/components/pages/report/ChangeReport');
const ProblemReport = () => import(/* webpackChunkName: "report" */'@/components/pages/report/ProblemReport');

export default [
  {
    path: '/report',
    name: 'report',
    component: Layout,
    meta: {
      title: '统计分析',
      icon: 'report-manage',
      roles: [
        'WF_REPORT_EVENT_STATUS_QUERY',
        'WF_REPORT_EVENT_QUERY',
        'WF_REPORT_KB_STATUS_QUERY',
        'WF_REPORT_KB_QUERY',
        'WF_REPORT_PM_CATEGORY_QUERY',
        'WF_REPORT_ASSET_QUERY',
        'WF_REPORT_PROBLEM',
        'WF_REPORT_CHANGE',
        'WF_REPORT_RELEASE',
        'DASHBOARD',
        'ASSET_DASHBOARD'
      ]
    },
    children: [
      {
        path: 'event-workflow',
        name: 'eventReport',
        component: EventReport,
        meta: {
          title: '事件报表',
          roles: ['WF_REPORT_EVENT_STATUS_QUERY', 'WF_REPORT_EVENT_QUERY'],
          componentName: 'EventReport',
          breadcrumb: [
            {
              name: '事件报表',
              path: '/report/event-workflow'
            }
          ]
        }
      },
      {
        path: 'request-workflow',
        name: 'requestReport',
        component: RequestReport,
        meta: {
          title: '请求报表',
          roles: ['WF_REPORT_EVENT_STATUS_QUERY', 'WF_REPORT_EVENT_QUERY'],
          componentName: 'RequestReport',
          breadcrumb: [
            {
              name: '请求报表',
              path: '/request/event-workflow'
            }
          ]
        }
      },
      {
        path: 'knowledge-workflow',
        name: 'knowledgeReport',
        component: KnowledgeReport,
        meta: {
          title: '知识报表',
          roles: ['WF_REPORT_KB_STATUS_QUERY', 'WF_REPORT_KB_QUERY'],
          componentName: 'KnowledgeReport',
          breadcrumb: [
            {
              name: '知识报表',
              path: '/report/knowledge-workflow'
            }
          ]
        }
      },
      {
        path: 'change-workflow',
        name: 'changeReport',
        component: ChangeReport,
        meta: {
          title: '变更报表',
          roles: ['WF_REPORT_CHANGE'],
          componentName: 'ChangeReport',
          breadcrumb: [
            {
              name: '变更报表',
              path: '/report/change-workflow'
            }
          ]
        }
      },
      {
        path: 'release-workflow',
        name: 'releaseReport',
        component: ReleaseReport,
        meta: {
          title: '发布报表',
          roles: ['WF_REPORT_RELEASE'],
          componentName: 'ReleaseReport',
          breadcrumb: [
            {
              name: '发布报表',
              path: '/report/release-workflow'
            }
          ]
        }
      },{
        path: 'problem-workflow',
        name: 'problemReport',
        component: ProblemReport,
        meta: {
          title: '问题报表',
          roles: ['WF_REPORT_PROBLEM'],
          componentName: 'ProblemReport',
          breadcrumb: [
            {
              name: '问题报表',
              path: '/report/problem-workflow'
            }
          ]
        }
      },
      {
        path: 'project-workflow',
        name: 'projectReport',
        component: ProjectReport,
        meta: {
          title: '项目报表',
          roles: ['WF_REPORT_PM_CATEGORY_QUERY'],
          componentName: 'ProjectReport',
          breadcrumb: [
            {
              name: '项目报表',
              path: '/report/project-workflow'
            }
          ]
        }
      },
      {
        path: 'asset-workflow',
        name: 'assetReport',
        component: AssetReport,
        meta: {
          title: '资产报表',
          roles: ['WF_REPORT_ASSET_QUERY'],
          componentName: 'AssetReport',
          breadcrumb: [
            {
              name: '资产报表',
              path: '/report/asset-workflow'
            }
          ]
        }
      },
      {
        path: 'platform',
        name: 'platform',
        meta: {
          title: '可视化平台',
          roles: ['DASHBOARD'],
          breadcrumb: [
            {
              name: '可视化平台',
              path: '/report/platform'
            }
          ]
        }
      },
      {
        path: 'asset-platform',
        name: 'assetPlatform',
        meta: {
          title: '资产大屏',
          roles: ['ASSET_DASHBOARD'],
          breadcrumb: [
            {
              name: '资产大屏',
              path: '/report/asset-platform'
            }
          ]
        }
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/report.js